import React from 'react';
import { lazy } from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Create a proper widget registry with lazy loading - updated to EXACTLY match WidgetPanel.js
const widgetRegistry = {
    1: () => import('../components/_dashboard/_widgets/DigitalWatch').then(module => module.default),
    2: () => import('../components/_dashboard/_widgets/AnalogWatch').then(module => module.default),
    3: () => import('../components/_dashboard/_widgets/ServiceQueueWidget').then(module => module.default),
    4: () => import('../components/_dashboard/_widgets/DailyProgressWidget').then(module => module.default),
    5: () => import('../components/_dashboard/_widgets/ProductCategoryWidget').then(module => {
        // Use Apple as the default brand
        const Component = module.default;
        return (props) => <Component brand="Apple" {...props} />;
    }),
    6: () => import('../components/_dashboard/_widgets/ProductCategoryWidget').then(module => {
        // Use Samsung as the brand
        const Component = module.default;
        return (props) => <Component brand="Samsung" {...props} />;
    }),
    7: () => import('../components/_dashboard/_widgets/DataSourceWidget').then(module => module.default),
    8: () => import('../components/_dashboard/_widgets/UserInfoWidget').then(module => module.default),
    9: () => import('../components/_dashboard/_widgets/ScreenshotWidget').then(module => module.default),
    10: () => import('../components/_dashboard/_widgets/EstimateStatusWidget').then(module => module.default),
    11: () => import('../components/_dashboard/_widgets/SamsungServiceStatusWidget').then(module => module.default)
};

// Widget config for display - must exactly match IDs in WidgetPanel.js
const widgetConfigs = [
    { id: 1, name: "Digital Watch" },
    { id: 2, name: "Analog Watch" },
    { id: 3, name: "Service Queue" },
    { id: 4, name: "Daily Progress" },
    { id: 5, name: "Apple Product Categories" },
    { id: 6, name: "Samsung Product Categories" },
    { id: 7, name: "Data Source" },
    { id: 8, name: "User Info" },
    { id: 9, name: "System Screenshot" },
    { id: 10, name: "Estimate Status" },
    { id: 11, name: "Samsung LP Status" }
];

class WidgetService {
    constructor() {
        this._componentCache = new Map();
        this._loadingPromises = new Map();
    }

    // Get widget configurations for display in panel
    getWidgets() {
        return widgetConfigs;
    }

    // Improved loadWidget with proper error handling
    async loadWidget(widgetId) {
        try {
            // Check if we have a loader for this widget
            if (!widgetRegistry[widgetId]) {
                throw new Error(`Widget with ID ${widgetId} not found in registry`);
            }
            
            // Load the component
            return await widgetRegistry[widgetId]();
        } catch (error) {
            console.error(`Error loading widget ${widgetId}:`, error);
            throw error;
        }
    }
}

export const widgetService = new WidgetService();
